import { render, staticRenderFns } from "./Comp31t2.vue?vue&type=template&id=0a7c7425&scoped=true&"
import script from "./Comp31t2.vue?vue&type=script&lang=js&"
export * from "./Comp31t2.vue?vue&type=script&lang=js&"
import style0 from "./Comp31t2.vue?vue&type=style&index=0&id=0a7c7425&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a7c7425",
  null
  
)

export default component.exports